// Auto-generated from Gymbook.csv — non modificare manualmente
export const EXERCISE_DB = [
  {
    "name": "Alzate Laterali a Una Mano al Cavo Basso",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Alzate Laterali alla Macchina",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Alzate Laterali con Manubrio da Sdraiati di Lato",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Alzate Frontali Alternate con Manubri",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Alzate Frontali a Una Mano al Cavo",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Alzate Frontali al Cavo",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Alzate Frontali con Bilanciere",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Alzate Frontali con Bilanciere da Seduti",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Alzate Frontali con Manubri",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Alzate Frontali con Un Manubrio",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Rotazioni Interne al Cavo in Piedi",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Distensioni Anteriori Sopra la Testa alla Smith Machine",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni Anteriori Sopra la Testa alla Smith Machine in Piedi",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni Anteriori Sopra la Testa con Bilanciere",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni Anteriori Sopra la Testa con Bilanciere in Piedi",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni Sopra la Testa a Una Mano con Rotazione con Manubrio",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Distensioni Sopra la Testa alla Macchina",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Distensioni Sopra la Testa con Rotazione con Manubri",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Distensioni a Una Mano con Landmine in Ginocchio",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni a Una Mano con Landmine in Piedi",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni con Landmine in Ginocchio",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni con Landmine in Piedi",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Alzate Frontali Alternate con Manubri a Martello",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Alzate Frontali a Una Mano al Cavo a Martello",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Alzate Frontali a Una Mano con Manubrio a Martello",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Alzate Laterali al Cavo da Piegati",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Alzate Laterali con Kettlebell",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio"
    ],
    "equipment": [
      "kettlebell"
    ]
  },
  {
    "name": "Alzate Laterali con Landmine",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Alzate Laterali con Manubri",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Alzate Laterali con Manubri da Piegati",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Alzate Laterali con Manubri da Sdraiati",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Alzate Laterali con Manubri da Seduti",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Flies Inversi al Cavo Alto",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Flies Inversi alla Macchina",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Rotazioni Esterne al Cavo in Piedi",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Distensioni Posteriori Sopra la Testa alla Smith Machine",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni Posteriori Sopra la Testa alla Smith Machine in Piedi",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni Posteriori Sopra la Testa con Bilanciere",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni Sopra la Testa a Una Mano con Manubrio in Piedi",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Distensioni Sopra la Testa con Manubri",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Distensioni Sopra la Testa con Manubri in Piedi",
    "zona": "spalle",
    "type": "isolation",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Trazioni al Mento a Una Mano con Manubrio",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio",
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Trazioni al Mento al Cavo",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio",
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Trazioni al Mento con Barra EZ",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio",
      "bicipiti"
    ],
    "equipment": [
      "barra_ez"
    ]
  },
  {
    "name": "Trazioni al Mento con Bilanciere",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio",
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Trazioni al Mento con Kettlebell",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio",
      "bicipiti"
    ],
    "equipment": [
      "kettlebell"
    ]
  },
  {
    "name": "Trazioni al Mento con Manubri",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio",
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Trazioni al Volto al Cavo",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio",
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Trazioni al Volto al Cavo da Seduti",
    "zona": "spalle",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio",
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Flies al Cavo",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Flies al Cavo Alto",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Flies al Cavo Basso",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Flies alla Macchina",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Flies con Manubri",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Flies su Panca Declinata con Manubri",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Flies su Panca Inclinata con Manubri",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Distensioni su Panca Inclinata alla Macchina",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Distensioni su Panca Inclinata al Cavo",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Distensioni su Panca Inclinata alla Smith Machine",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni su Panca Inclinata con Bilanciere",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni su Panca Inclinata con Manubri",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Distensioni su Panca Piana al Cavo",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Distensioni su Panca Piana alla Smith Machine",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni su Panca Piana con Bilanciere",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni su Panca Piana con Bilanciere a Presa Larga",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni su Panca Piana con Manubri",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Piegamenti",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Piegamenti Declinati",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Piegamenti Declinati su Palla",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi",
      "tricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Chest Press",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Chest Press al Cavo",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Distensioni su Panca Declinata al Cavo",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Distensioni su Panca Declinata alla Smith Machine",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni su Panca Declinata con Bilanciere",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni su Panca Declinata con Manubri",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Distensioni su Panca Piana alla Macchina",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Flies ai cavi su panca",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Piegamenti Inclinati",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Piegamenti Inclinati su Palla",
    "zona": "torace",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Pull-Over con Bilanciere",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "dorsali",
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Pull-Over con Manubrio",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "dorsali",
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Pull-Over con Manubrio su Palla",
    "zona": "torace",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "dorsali",
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Shrugs alla Macchina",
    "zona": "schiena",
    "type": "isolation",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Shrugs con Barra Esagonale",
    "zona": "schiena",
    "type": "isolation",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Shrugs con Bilanciere",
    "zona": "schiena",
    "type": "isolation",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Shrugs con Manubri",
    "zona": "schiena",
    "type": "isolation",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Rematore al Cavo da Seduti a Presa Larga",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Rematore alla Macchina da Seduti a Presa Larga",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Rematore alla Smith Machine",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Rematore con Barra T",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Rematore con Barra T da Sdraiati",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Rematore con Bilanciere",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Rematore con Bilanciere da Sdraiati",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Rematore con Landmine",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Rematore con Manubri",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Rematore su Panca Inclinata con Bilanciere",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Rematore su Panca Inclinata con Manubri",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Rematore Renegade con Kettlebell",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "lombari",
      "bicipiti",
      "addominali",
      "obliqui",
      "glutei"
    ],
    "equipment": [
      "kettlebell"
    ]
  },
  {
    "name": "Rematore Renegade con Manubri",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "lombari",
      "bicipiti",
      "addominali",
      "obliqui",
      "glutei"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Rematore a Una Mano con Kettlebell",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "bicipiti"
    ],
    "equipment": [
      "kettlebell"
    ]
  },
  {
    "name": "Rematore a Una Mano con Landmine",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Rematore a Una Mano con Manubrio",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "deltoidi",
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Lat Pull-Downs Posteriori al Cavo Alto a Presa Larga",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Lat Pull-Downs al Cavo Alto a Presa Larga",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Trazioni alla Sbarra",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "dorsali",
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stacco alla Smith Machine",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "lombari",
      "glutei",
      "quadricipiti",
      "dorsali",
      "addominali",
      "obliqui",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Stacco con Bilanciere",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "lombari",
      "glutei",
      "quadricipiti",
      "dorsali",
      "addominali",
      "obliqui",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Stacco con Manubri",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "lombari",
      "glutei",
      "quadricipiti",
      "dorsali",
      "addominali",
      "obliqui",
      "ischio-crurali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Stacco con Barra Esagonale",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio",
      "glutei",
      "quadricipiti",
      "dorsali",
      "lombari",
      "addominali",
      "obliqui",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Rematore al Cavo da Seduti",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "deltoidi",
      "trapezio",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Rematore alla Macchina da Seduti",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "deltoidi",
      "trapezio",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Rematore con Bilanciere a Presa Inversa",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "deltoidi",
      "trapezio",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Rematore con Manubri a Presa Inversa",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "deltoidi",
      "trapezio",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Rematore su Panca Inclinata con Bilanciere a Presa Inversa",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "deltoidi",
      "trapezio",
      "lombari",
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Lat Pull-Downs a Una Mano al Cavo Alto",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "deltoidi",
      "trapezio",
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Lat Pull-Downs al Cavo Alto a Presa Stretta",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "deltoidi",
      "trapezio",
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Trazioni alla Sbarra a Presa Stretta",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "deltoidi",
      "trapezio",
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Pull-Over al Cavo da Seduti",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Pull-Over alla Macchina",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "pettorali",
      "tricipiti"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Lat Pull-Downs al Cavo Alto",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "trapezio",
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Lat Pull-Downs alla Macchina",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "trapezio",
      "bicipiti"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Lat Pull-Downs al Cavo Alto a Braccia Tese",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Lat Pull-Downs al Cavo Alto a Presa Inversa",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "bicipiti",
      "trapezio"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Lat Pull-Downs alla Macchina a Presa Inversa",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "bicipiti",
      "trapezio"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Trazioni alla Sbarra a Presa Inversa",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "bicipiti",
      "trapezio"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Alzate del Corpo Superiore alla Macchina",
    "zona": "schiena",
    "type": "isolation",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Alzate del Corpo Superiore",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari",
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Alzate del Corpo Superiore su Palla",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari",
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Supermans",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari",
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stacco Sumo con Bilanciere",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari",
      "glutei",
      "quadricipiti",
      "trapezio",
      "dorsali",
      "addominali",
      "obliqui",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Stacco Rumeno con Bilanciere",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari",
      "glutei",
      "ischio-crurali",
      "trapezio",
      "dorsali",
      "quadricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Stacco Rumeno con Kettlebell",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari",
      "glutei",
      "ischio-crurali",
      "trapezio",
      "dorsali",
      "quadricipiti"
    ],
    "equipment": [
      "kettlebell"
    ]
  },
  {
    "name": "Stacco Rumeno con Manubri",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari",
      "glutei",
      "ischio-crurali",
      "trapezio",
      "dorsali",
      "quadricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Stacco con Bilanciere a Gambe Tese",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari",
      "glutei",
      "ischio-crurali",
      "trapezio",
      "dorsali",
      "quadricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Stacco con Manubri a Gambe Tese",
    "zona": "schiena",
    "type": "compound",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari",
      "glutei",
      "ischio-crurali",
      "trapezio",
      "dorsali",
      "quadricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Dips alla Macchina",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti",
      "deltoidi"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Dips alle Parallele",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti",
      "deltoidi"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Distensioni su Panca Inclinata con Manubri a Presa Stretta",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti",
      "deltoidi"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Distensioni su Panca Piana con Bilanciere a Presa Stretta",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti",
      "deltoidi"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Distensioni su Panca Piana con Manubri a Presa Stretta",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti",
      "deltoidi"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Piegamenti Inclinati a Presa Stretta",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti",
      "deltoidi"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Piegamenti a Presa Stretta",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "tricipiti",
      "deltoidi"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "French Presses a Una Mano al Cavo Alto in Piedi",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "French Presses a Una Mano con Manubrio da Seduti",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "French Presses a Una Mano con Manubrio in Piedi",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "French Presses al Cavo Alto da Seduti",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "French Presses al Cavo Basso da Sdraiati",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "French Presses al Cavo Basso in Piedi",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "French Presses al Cavo Basso in Piedi a Martello",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "French Presses con Barra EZ da Sdraiati",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "barra_ez"
    ]
  },
  {
    "name": "French Presses con Barra EZ da Seduti",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "barra_ez"
    ]
  },
  {
    "name": "French Presses con Bilanciere da Sdraiati",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "French Presses con Manubri da Sdraiati",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "French Presses con Un Manubrio da Seduti",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "French Presses con Un Manubrio in Piedi",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "French Presses su Panca Inclinata al Cavo Basso",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Kickbacks Tricipiti",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Tricipiti a Una Mano al Cavo a Martello",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Tricipiti al Cavo",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Tricipiti al Cavo a Martello",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Tricipiti alla Macchina",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Dips su Palla",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti",
      "deltoidi",
      "pettorali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Dips su Panca",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti",
      "deltoidi",
      "pettorali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Tricipiti a Una Mano al Cavo a Presa Inversa",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti",
      "avambracci"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Tricipiti al Cavo a Presa Inversa",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti",
      "avambracci"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Curls Alternati a Martello",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Curls Alternati con Manubri",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Curls Alternati su Panca Inclinata a Martello",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Curls Alternati su Panca Inclinata con Manubri",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Curls Concentrati",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Curls Concentrati al Cavo",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Curls a Martello",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Curls a Una Mano al Cavo Alto",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Curls a Una Mano al Cavo Basso",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Curls al Cavo Alto",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Curls al Cavo Basso",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Curls al Cavo Basso a Martello",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Curls con Barra EZ",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "barra_ez"
    ]
  },
  {
    "name": "Curls con Barra EZ a Presa Larga",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "barra_ez"
    ]
  },
  {
    "name": "Curls con Bilanciere",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Curls con Bilanciere a Presa Larga",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Curls con Manubri",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Curls su Panca Inclinata a Martello",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Curls su Panca Inclinata con Manubri",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Preacher Curls Alternati a Martello",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Preacher Curls Alternati con Manubri",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Preacher Curls a Martello",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Preacher Curls a Una Mano alla Macchina",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Preacher Curls a Una Mano con Manubrio in Piedi",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Preacher Curls al Cavo",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Preacher Curls alla Macchina",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Preacher Curls con Barra EZ",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "barra_ez"
    ]
  },
  {
    "name": "Preacher Curls con Bilanciere",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Preacher Curls con Manubri",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Spider Curls a Martello",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Spider Curls con Barra EZ",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "barra_ez"
    ]
  },
  {
    "name": "Spider Curls con Bilanciere",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Spider Curls con Manubri",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Curls Alternati con Rotazione con Manubri",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti",
      "deltoidi"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Curls Alternati con Rotazione su Panca Inclinata con Manubri",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti",
      "deltoidi"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Curls con Rotazione con Manubri",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti",
      "deltoidi"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Curls con Rotazione su Panca Inclinata con Manubri",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "bicipiti",
    "muscles": [
      "bicipiti",
      "deltoidi"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Curls dei Polsi al Cavo a Presa Inversa",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Curls dei Polsi con Bilanciere a Presa Inversa",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Curls dei Polsi con Manubri a Presa Inversa",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Curls con Bilanciere a Presa Inversa",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci",
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Preacher Curls al Cavo a Presa Inversa",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci",
      "bicipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Preacher Curls con Barra EZ a Presa Inversa",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci",
      "bicipiti"
    ],
    "equipment": [
      "barra_ez"
    ]
  },
  {
    "name": "Preacher Curls con Bilanciere a Presa Inversa",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci",
      "bicipiti"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Preacher Curls con Manubri a Presa Inversa",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci",
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Spider Curls con Manubri a Presa Inversa",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci",
      "bicipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Camminata del Contadino con Barra Esagonale",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci",
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "polpacci",
      "deltoidi",
      "trapezio",
      "lombari",
      "tricipiti",
      "bicipiti",
      "addominali",
      "obliqui",
      "adduttori"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Camminata del Contadino con Kettlebell",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci",
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "polpacci",
      "deltoidi",
      "trapezio",
      "lombari",
      "tricipiti",
      "bicipiti",
      "addominali",
      "obliqui",
      "adduttori"
    ],
    "equipment": [
      "kettlebell"
    ]
  },
  {
    "name": "Camminata del Contadino con Manubri",
    "zona": "braccia",
    "type": "compound",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci",
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "polpacci",
      "deltoidi",
      "trapezio",
      "lombari",
      "tricipiti",
      "bicipiti",
      "addominali",
      "obliqui",
      "adduttori"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Curls dei Polsi al Cavo",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Curls dei Polsi con Bilanciere",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Curls dei Polsi con Kettlebell",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci"
    ],
    "equipment": [
      "kettlebell"
    ]
  },
  {
    "name": "Curls dei Polsi con Manubri",
    "zona": "braccia",
    "type": "isolation",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Planks",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari",
      "addominali",
      "obliqui",
      "deltoidi",
      "trapezio",
      "glutei",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Planks Laterali",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari",
      "obliqui",
      "deltoidi",
      "addominali",
      "glutei",
      "quadricipiti",
      "adduttori"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Insetto Morto",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "deltoidi",
      "dorsali",
      "lombari",
      "obliqui",
      "glutei",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Insetto Morto con Palla",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "deltoidi",
      "dorsali",
      "lombari",
      "obliqui",
      "glutei",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Crunches al Cavo Alto da Seduti",
    "zona": "addome",
    "type": "isolation",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Crunches al Cavo Alto in Ginocchio",
    "zona": "addome",
    "type": "isolation",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Alzate di Gambe",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Alzate di Gambe Inclinate",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Alzate di Gambe alla Macchina",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "quadricipiti"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Alzate di Gambe alla Sbarra",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Battimenti di Gambe",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Crunches",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Crunches alla Macchina",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "quadricipiti"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Crunches su Palla",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Sit-Ups",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Sit-Ups Inclinati",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Rollouts con Ab-Wheel",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "deltoidi",
      "dorsali",
      "lombari"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Rollouts con Barra EZ",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "deltoidi",
      "dorsali",
      "lombari"
    ],
    "equipment": [
      "barra_ez"
    ]
  },
  {
    "name": "Rollouts con Bilanciere",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "deltoidi",
      "dorsali",
      "lombari"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Rollouts con Manubri",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "deltoidi",
      "dorsali",
      "lombari"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Crunches con Rotazione",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Sit-Ups Inclinati con Rotazione",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Sit-Ups con Rotazione",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Mountain Climber",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "quadricipiti",
      "deltoidi",
      "trapezio",
      "lombari",
      "glutei"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Piegamenti Laterali al Cavo",
    "zona": "addome",
    "type": "isolation",
    "primaryMuscle": "obliqui",
    "muscles": [
      "obliqui"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Piegamenti Laterali con Manubrio",
    "zona": "addome",
    "type": "isolation",
    "primaryMuscle": "obliqui",
    "muscles": [
      "obliqui"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Torsioni del Busto al Cavo",
    "zona": "addome",
    "type": "isolation",
    "primaryMuscle": "obliqui",
    "muscles": [
      "obliqui"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Torsioni del Busto al Cavo da Seduti",
    "zona": "addome",
    "type": "isolation",
    "primaryMuscle": "obliqui",
    "muscles": [
      "obliqui"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Torsioni del Busto con Bilanciere",
    "zona": "addome",
    "type": "isolation",
    "primaryMuscle": "obliqui",
    "muscles": [
      "obliqui"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Pallof Press al Cavo da Sdraiati",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "obliqui",
    "muscles": [
      "obliqui",
      "deltoidi",
      "pettorali",
      "lombari",
      "tricipiti",
      "bicipiti",
      "addominali"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Pallof Press al Cavo",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "obliqui",
    "muscles": [
      "obliqui",
      "deltoidi",
      "pettorali",
      "lombari",
      "tricipiti",
      "bicipiti",
      "addominali",
      "glutei",
      "adduttori"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Pallof Press al Cavo in Ginocchio",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "obliqui",
    "muscles": [
      "obliqui",
      "deltoidi",
      "pettorali",
      "lombari",
      "tricipiti",
      "bicipiti",
      "addominali",
      "glutei",
      "adduttori"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Torsioni del Busto alla Macchina",
    "zona": "addome",
    "type": "isolation",
    "primaryMuscle": "obliqui",
    "muscles": [
      "obliqui",
      "addominali"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Torsioni del Busto con Landmine",
    "zona": "addome",
    "type": "isolation",
    "primaryMuscle": "obliqui",
    "muscles": [
      "obliqui",
      "addominali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Torsioni alla Russa",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "obliqui",
    "muscles": [
      "obliqui",
      "addominali",
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Torsioni alla Russa con Kettlebell",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "obliqui",
    "muscles": [
      "obliqui",
      "addominali",
      "quadricipiti"
    ],
    "equipment": [
      "kettlebell"
    ]
  },
  {
    "name": "Torsioni alla Russa con Manubrio",
    "zona": "addome",
    "type": "compound",
    "primaryMuscle": "obliqui",
    "muscles": [
      "obliqui",
      "addominali",
      "quadricipiti"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Swing a Una Mano con Kettlebell",
    "zona": "glutei",
    "type": "compound",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari",
      "obliqui",
      "glutei",
      "ischio-crurali",
      "deltoidi",
      "pettorali",
      "trapezio",
      "dorsali",
      "addominali",
      "quadricipiti",
      "polpacci"
    ],
    "equipment": [
      "kettlebell"
    ]
  },
  {
    "name": "Swing con Kettlebell",
    "zona": "glutei",
    "type": "compound",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari",
      "glutei",
      "ischio-crurali",
      "deltoidi",
      "pettorali",
      "trapezio",
      "dorsali",
      "addominali",
      "obliqui",
      "quadricipiti",
      "polpacci"
    ],
    "equipment": [
      "kettlebell"
    ]
  },
  {
    "name": "Swing con Manubrio",
    "zona": "glutei",
    "type": "compound",
    "primaryMuscle": "lombari",
    "muscles": [
      "lombari",
      "glutei",
      "ischio-crurali",
      "deltoidi",
      "pettorali",
      "trapezio",
      "dorsali",
      "addominali",
      "obliqui",
      "quadricipiti",
      "polpacci"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Abduzione della Gamba al Cavo",
    "zona": "glutei",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Abduzione della Gamba alla Macchina da Seduti",
    "zona": "glutei",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Abduzione della Gamba alla Macchina in Piedi",
    "zona": "glutei",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Abduzione della Gamba da Sdraiati",
    "zona": "glutei",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Hip Thrust",
    "zona": "glutei",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Hip Thrust alla Smith Machine",
    "zona": "glutei",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Hip Thrust con Bilanciere",
    "zona": "glutei",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Hip Thrust con Manubri",
    "zona": "glutei",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Hip Thrust su Palla",
    "zona": "glutei",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Battimenti di Gambe Inversi su Panca",
    "zona": "glutei",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Estensioni dell'Anca",
    "zona": "glutei",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Estensioni dell'Anca al Cavo",
    "zona": "glutei",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Estensioni dell'Anca alla Macchina",
    "zona": "glutei",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Estensioni dell'Anca con Ginocchio Flesso",
    "zona": "glutei",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Ponte",
    "zona": "glutei",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Ponte con Bilanciere",
    "zona": "glutei",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Ponte con Manubrio",
    "zona": "glutei",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Ponte su Panca",
    "zona": "glutei",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Ponte su Panca con Bilanciere",
    "zona": "glutei",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Affondi con Bilanciere",
    "zona": "glutei",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Affondi con Kettlebell",
    "zona": "glutei",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali"
    ],
    "equipment": [
      "kettlebell"
    ]
  },
  {
    "name": "Affondi con Manubri",
    "zona": "glutei",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Burpees",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "quadricipiti",
      "ischio-crurali",
      "polpacci",
      "deltoidi",
      "tricipiti",
      "addominali",
      "obliqui",
      "adduttori"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Squat con Un Manubrio",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "lombari",
      "addominali",
      "obliqui",
      "adduttori"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Goblet Squat con Kettlebell",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "lombari",
      "addominali",
      "obliqui",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "kettlebell"
    ]
  },
  {
    "name": "Goblet Squat con Manubrio",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "lombari",
      "addominali",
      "obliqui",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Squat",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "lombari",
      "addominali",
      "obliqui",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Squat Frontali con Bilanciere",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "lombari",
      "addominali",
      "obliqui",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Squat Frontali con Manubri",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "lombari",
      "addominali",
      "obliqui",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Squat alla Smith Machine",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "lombari",
      "addominali",
      "obliqui",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Squat con Bilanciere",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "lombari",
      "addominali",
      "obliqui",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Squat con Manubri",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "lombari",
      "addominali",
      "obliqui",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Squat su Panca con Bilanciere",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "lombari",
      "addominali",
      "obliqui",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Squat su Panca con Manubri",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "lombari",
      "addominali",
      "obliqui",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Pistol Squat",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "lombari",
      "addominali",
      "obliqui",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Pistol Squat con Kettlebell",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "lombari",
      "addominali",
      "obliqui",
      "ischio-crurali"
    ],
    "equipment": [
      "kettlebell"
    ]
  },
  {
    "name": "Hack Squat alla Macchina",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Leg Press alla Macchina",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti",
      "glutei",
      "femorali"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Hack Squat con Landmine",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Split Squat Bulgaro",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Split Squat Bulgaro con Bilanciere",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Split Squat Bulgaro con Cintura alla Macchina",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Split Squat Bulgaro con Manubri",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Squat Pendolo alla Macchina",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Squat con Cintura alla Macchina",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Wall Sit",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Salti a Stella",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "polpacci",
      "deltoidi",
      "pettorali",
      "adduttori"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Estensioni delle Gambe",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Estensioni delle Gambe a Una Gamba",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Estensioni delle Gambe a Una Gamba al Cavo",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Distensioni delle Gambe",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti",
      "glutei",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Distensioni delle Gambe a Una Gamba",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti",
      "glutei",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Distensioni delle Gambe a Una Gamba da Seduti",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti",
      "glutei",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Distensioni delle Gambe da Seduti",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti",
      "glutei",
      "adduttori",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Sissy Squat",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti",
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Sissy Squat con Piastra",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti",
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Sissy Squat in Ginocchio",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti",
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Squat con Bilanciere a Gambe Larghe",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti",
      "adduttori",
      "lombari",
      "addominali",
      "obliqui",
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Sumo Squat con Cintura alla Macchina",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti",
      "adduttori",
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Mezzi Burpees",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti",
      "ischio-crurali",
      "polpacci",
      "deltoidi",
      "pettorali",
      "tricipiti",
      "addominali",
      "obliqui",
      "adduttori"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Adduzione al Cavo",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "adduttori",
    "muscles": [
      "adduttori"
    ],
    "equipment": [
      "cavo"
    ]
  },
  {
    "name": "Adduzione alla Macchina",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "adduttori",
    "muscles": [
      "adduttori"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Good Mornings alla Smith Machine",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "ischio-crurali",
    "muscles": [
      "ischio-crurali",
      "lombari",
      "glutei"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Good Mornings con Bilanciere",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "ischio-crurali",
    "muscles": [
      "ischio-crurali",
      "lombari",
      "glutei"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Good Mornings con Bilanciere da Seduti",
    "zona": "gambe",
    "type": "compound",
    "primaryMuscle": "ischio-crurali",
    "muscles": [
      "ischio-crurali",
      "lombari",
      "glutei"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Flessioni delle Gambe Nordiche",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "ischio-crurali",
    "muscles": [
      "ischio-crurali",
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Flessioni delle Gambe a Una Gamba da Sdraiati",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "ischio-crurali",
    "muscles": [
      "ischio-crurali",
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Flessioni delle Gambe a Una Gamba da Seduti",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "ischio-crurali",
    "muscles": [
      "ischio-crurali",
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Flessioni delle Gambe da Sdraiati",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "ischio-crurali",
    "muscles": [
      "ischio-crurali",
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Flessioni delle Gambe da Seduti",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "ischio-crurali",
    "muscles": [
      "ischio-crurali",
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Flessioni delle Gambe in Piedi",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "ischio-crurali",
    "muscles": [
      "ischio-crurali",
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Alzate Polpacci a Una Gamba con Manubrio in Piedi",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "polpacci",
    "muscles": [
      "polpacci"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Alzate Polpacci a Una Gamba in Piedi",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "polpacci",
    "muscles": [
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Alzate Polpacci alla Macchina da Piegati",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "polpacci",
    "muscles": [
      "polpacci"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Alzate Polpacci alla Macchina da Seduti",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "polpacci",
    "muscles": [
      "polpacci"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Alzate Polpacci alla Macchina in Piedi",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "polpacci",
    "muscles": [
      "polpacci"
    ],
    "equipment": [
      "macchina"
    ]
  },
  {
    "name": "Alzate Polpacci con Bilanciere da Seduti",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "polpacci",
    "muscles": [
      "polpacci"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Alzate Polpacci con Bilanciere in Piedi",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "polpacci",
    "muscles": [
      "polpacci"
    ],
    "equipment": [
      "bilanciere"
    ]
  },
  {
    "name": "Alzate Polpacci con Manubri da Seduti",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "polpacci",
    "muscles": [
      "polpacci"
    ],
    "equipment": [
      "manubri"
    ]
  },
  {
    "name": "Alzate Polpacci in Piedi",
    "zona": "gambe",
    "type": "isolation",
    "primaryMuscle": "polpacci",
    "muscles": [
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Nuoto",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "dorsali",
      "tricipiti",
      "bicipiti",
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "polpacci",
      "trapezio",
      "lombari",
      "addominali",
      "obliqui",
      "adduttori"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Onde Alternate con Corda Ondulatoria",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio",
      "dorsali",
      "tricipiti",
      "bicipiti",
      "avambracci",
      "pettorali",
      "lombari",
      "addominali",
      "obliqui",
      "glutei",
      "quadricipiti",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Onde Doppie con Corda Ondulatoria",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio",
      "dorsali",
      "tricipiti",
      "bicipiti",
      "avambracci",
      "pettorali",
      "lombari",
      "addominali",
      "obliqui",
      "glutei",
      "quadricipiti",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Boxe",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "tricipiti",
      "bicipiti",
      "pettorali",
      "trapezio",
      "dorsali",
      "lombari",
      "addominali",
      "obliqui",
      "glutei",
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Remi",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "ischio-crurali",
      "deltoidi",
      "trapezio",
      "lombari",
      "bicipiti",
      "glutei",
      "quadricipiti",
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Bicicletta",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Bicicletta Stazionaria",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Bicicletta Ellittica",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "deltoidi",
      "pettorali",
      "trapezio",
      "dorsali",
      "lombari",
      "tricipiti",
      "bicipiti",
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Salto Doppio alla Corda",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "polpacci",
      "deltoidi",
      "bicipiti",
      "avambracci",
      "adduttori"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Salto alla Corda",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "polpacci",
      "deltoidi",
      "bicipiti",
      "avambracci",
      "adduttori"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Jogging",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "polpacci",
      "adduttori"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Jogging su Tapis Roulant",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "polpacci",
      "adduttori"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Scale Stazionarie",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "polpacci",
      "adduttori"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Walking",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "polpacci",
      "adduttori"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Walking su Tapis Roulant",
    "zona": "cardio",
    "type": "compound",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "quadricipiti",
      "ischio-crurali",
      "polpacci",
      "adduttori"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Trazione del Gomito Avanti",
    "zona": "stretching",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "trapezio",
      "dorsali",
      "tricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Estensione delle Braccia Dietro con Mani verso l'Interno",
    "zona": "stretching",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Rotazione del Busto al Muro a Braccio Teso",
    "zona": "stretching",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "pettorali",
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching in Posizione Bambino",
    "zona": "stretching",
    "type": "compound",
    "primaryMuscle": "deltoidi",
    "muscles": [
      "deltoidi",
      "dorsali",
      "pettorali",
      "lombari"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Rotazione del Busto al Muro con Braccio Flesso",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Inclino del Busto all'Angolo a Braccia Tese",
    "zona": "stretching",
    "type": "compound",
    "primaryMuscle": "pettorali",
    "muscles": [
      "pettorali",
      "deltoidi",
      "trapezio",
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Inclinazione della Testa da Seduti con Gambe Incrociate",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Inclinazione della Testa in Piedi",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Trazione del Braccio Dietro",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "trapezio",
    "muscles": [
      "trapezio"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Sospeso",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Piegamento Laterale al Muro",
    "zona": "stretching",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "obliqui",
      "glutei"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Estensione delle Braccia Sopra con Mani verso l'Esterno",
    "zona": "stretching",
    "type": "compound",
    "primaryMuscle": "dorsali",
    "muscles": [
      "dorsali",
      "avambracci",
      "bicipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Trazione del Gomito Dietro",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "tricipiti",
    "muscles": [
      "tricipiti",
      "dorsali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Estensione delle Braccia Avanti con Mani verso l'Esterno",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "avambracci",
    "muscles": [
      "avambracci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching in Posizione Cobra",
    "zona": "stretching",
    "type": "compound",
    "primaryMuscle": "addominali",
    "muscles": [
      "addominali",
      "obliqui",
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Rotazione dell'Anca da Sdraiati",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "obliqui"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Trazione della Gamba da Sdraiati con Ginocchio Flesso",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "glutei",
    "muscles": [
      "glutei",
      "ischio-crurali"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Trazione del Piede Dietro da Sdraiati di Lato",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Trazione del Piede Dietro in Piedi",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Affondo in Ginocchio",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "quadricipiti",
    "muscles": [
      "quadricipiti",
      "glutei"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Trazione della Gamba da Sdraiati a Gamba Tesa",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "ischio-crurali",
    "muscles": [
      "ischio-crurali",
      "glutei"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Estensione delle Gambe a Una Gamba in Piedi",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "ischio-crurali",
    "muscles": [
      "ischio-crurali",
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  },
  {
    "name": "Stretching Affondo al Muro in Piedi",
    "zona": "stretching",
    "type": "isolation",
    "primaryMuscle": "polpacci",
    "muscles": [
      "polpacci"
    ],
    "equipment": [
      "corpo_libero"
    ]
  }
];

export function findExercise(name) {
  if (!name) return null;
  const n = name.toLowerCase().trim();
  let found = EXERCISE_DB.find(e => e.name.toLowerCase() === n);
  if (found) return found;
  found = EXERCISE_DB.find(e => n.includes(e.name.toLowerCase()) || e.name.toLowerCase().includes(n));
  return found || null;
}
